/**
 * Valeur des ComboBoxData
 */
export enum EnumComboBoxValue {
    Last = 1,
    Previous = 2,
    Current = 3,
    First = 4
}